<template>
  <AddFaculty update />
</template>
<script>
import appConfig from '@/app.config'
import AddFaculty from '../../../../components/mooc/head/faculties/AddFaculty.vue'
export default {
  page: {
    title: 'مدیریت دانشکده',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-edit-faculty',
  components: {
    AddFaculty,
  },
}
</script>
